module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "payment-method",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    staticClass: "center-align link",
    attrs: {
      "flat": "",
      "hover": "",
      "height": "120"
    },
    on: {
      "click": function($event) {
        return _vm.$emit(_vm.method, _vm.value)
      }
    }
  }, [_c('div', {
    staticClass: "pt-4"
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("mdi-plus")])], 1), _vm._v(" "), _vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09338bcb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/add-card.vue
// module id = 694
// module chunks = 1